import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { HttpClient } from "@angular/common/http";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { AccessGroupService } from "./../access-group.service";
import { Store } from "@ngrx/store";
import { TeamReportServiceService } from "../team-report/team-report-service.service";
import { Subject } from "rxjs";
import { takeUntil, debounceTime, distinctUntilChanged } from "rxjs/operators";
import acme_roster from "./acme_roster.json";

@Component({
  selector: "app-orgs",
  templateUrl: "./orgs.component.html",
  styleUrls: ["./orgs.component.scss"],
})
export class OrgsComponent implements OnInit, OnDestroy {
  organizations: any;
  meta: any;
  curPage: any;
  item: any;
  pageLen: any;
  query_string: any;
  itemsByPage: any;
  isLoading: boolean = false;
  loadError: boolean = false;
  Query_String: any;
  name: any;
  modal: any;
  orgName: any;
  parentOrgId: any = null;
  addingOrg: boolean = false;
  editOrgs: any;
  savedOrg: any;
  count: any;
  ngrxAccessGroup: any;
  prevRecordName: string;
  delRoster: boolean = false;
  org;
  deleteOrg;
  deleteIndex;
  tableHierarView: any = "table";
  rosterId: any;
  searchQuery: string;
  isGlobalSearch: boolean = false;
  nameOrder: 'asc' | 'desc' = 'asc';

  private destroy$ = new Subject<void>();
  private searchSubject$ = new Subject<string>();
  private paginationListenerAttached = false;

  constructor(
    public accessgroup: AccessGroupService,
    public http: HttpClient,
    private modalService: NgbModal,
    private router: Router,
    public store: Store<any>,
    public teamReportService: TeamReportServiceService
  ) {}

  ngOnInit() {
    localStorage.getItem("rostertableHierView")
      ? (this.tableHierarView = localStorage.getItem("rostertableHierView"))
      : "table";

    this.ngrxAccessGroup = this.store.select<any>(
      (state) => state.profile.accessGroupData
    );
    this.ngrxAccessGroup.pipe(takeUntil(this.destroy$)).subscribe(
      (message) => {
        if (message && message["main_menu"] && !message["main_menu"].orgs) {
          this.router.navigate(["/dashboard"]);
        }
      }
    );

    // Debounce search input — wait 300ms after last keystroke before firing API call
    this.searchSubject$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      takeUntil(this.destroy$)
    ).subscribe(name => {
      this.executeSearch(name);
    });

    this.editOrgs = -1;
    this.itemsByPage = 10;
    this.buildQueryString();
    this.isLoading = true;
    this.loadError = false;
    this.getDataFn();
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private buildQueryString() {
    this.query_string =
      environment.profileURL +
      `/api/v1/roster_organizations.json?name_order=${this.nameOrder}`;
    this.Query_String = this.query_string;
  }

  public toggleSort(column: string) {
    if (column === 'name') {
      this.nameOrder = this.nameOrder === 'asc' ? 'desc' : 'asc';
    }
    this.buildQueryString();
    if (this.name) {
      this.query_string = this.query_string + "&name=" + this.name;
    }
    this.paginationListenerAttached = false;
    this.isLoading = true;
    this.loadError = false;
    this.http.get(`${this.query_string}&per_page=${this.itemsByPage}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.organizations = data["organizations"];
          if (!this.name) {
            this.organizations.unshift(acme_roster);
          }
          this.meta = data["meta"];
          // Count includes ACME when it's added client-side
          this.count = this.meta.total_count + (!this.name ? 1 : 0);
          // Total pages needs to include ACME too
          this.pageLen = Math.ceil(this.count / this.itemsByPage);
          this.curPage = 0;
          this.isLoading = false;
          this.loadError = false;
          this.item = [];
          for (var i = 1; i <= this.pageLen; i++) {
            this.item.push(i);
          }
          if (this.count > this.itemsByPage) {
            // Defer render until Angular has rendered the #holder element
            setTimeout(() => this.render(this.curPage, this.item, true), 0);
          }
        },
        (error) => {
          this.isLoading = false;
          this.loadError = true;
        }
      );
  }

  getDataFn() {
    this.http
      .get(`${this.query_string}&per_page=${this.itemsByPage}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (data) => {
          this.organizations = data["organizations"];
          this.organizations.unshift(acme_roster);
          this.meta = data["meta"];
          // Count includes ACME when it's added client-side
          this.count = data["meta"].total_count + 1;
          this.pageLen = Math.ceil(this.count / this.itemsByPage);
          this.curPage = 0;
          this.isLoading = false;
          this.loadError = false;
          this.item = [];
          for (var i = 1; i <= this.pageLen; i++) {
            this.item.push(i);
          }
          if (this.count > this.itemsByPage) {
            setTimeout(() => this.render(this.curPage, this.item, true), 0);
          }
        },
        (error) => {
          this.isLoading = false;
          this.loadError = true;
        }
      );
  }

  public isPageInRange = function (
    curPage,
    index,
    maxPages,
    pageBefore,
    pageAfter
  ) {
    if (index <= 1) {
      return true;
    }
    if (index >= maxPages - 2) {
      return true;
    }
    if (index >= curPage - pageBefore && index <= curPage + pageAfter) {
      return true;
    }
  };

  public render = function (curPage, item, first?) {
    var separatorAdded = false;
    var holder = document.querySelector("#holder");
    if (!holder) return;

    // Build pagination using safe DOM methods
    holder.textContent = '';
    for (var i in item) {
      if (this.isPageInRange(curPage, i, this.pageLen, 2, 2)) {
        var li = document.createElement('li');
        li.setAttribute('data-page', i);
        li.textContent = item[i];
        holder.appendChild(li);
        separatorAdded = false;
      } else {
        if (!separatorAdded) {
          var sep = document.createElement('li');
          sep.className = 'separator';
          holder.appendChild(sep);
          separatorAdded = true;
        }
      }
    }

    if (this.meta.total_count > this.itemsByPage) {
      var activeEl = document.querySelector('#holder>li[data-page="' + curPage + '"]');
      if (activeEl) {
        activeEl.classList.add("active");
      }
      if (first && !this.paginationListenerAttached) {
        this.paginationListenerAttached = true;
        holder.addEventListener("click", (e) => {
          if (!e.target["attributes"]["data-page"]?.value) {
            return;
          }

          curPage = parseInt(e.target["attributes"]["data-page"].value);
          var page_number = curPage + 1;
          this.isLoading = true;
          this.loadError = false;
          this.http.get(`${this.query_string}&page=${page_number}&per_page=${this.itemsByPage}`)
            .pipe(takeUntil(this.destroy$))
            .subscribe(
            (data) => {
              this.organizations = data["organizations"];
              this.meta = data["meta"];
              this.count = this.meta.total_count + (!this.name ? 1 : 0);
              this.pageLen = Math.ceil(this.count / this.itemsByPage);
              this.isLoading = false;
              this.item = [];
              for (var i = 1; i <= this.pageLen; i++) {
                this.item.push(i);
              }
            },
            (error) => {
              this.isLoading = false;
              this.loadError = true;
            }
          );
          this.render(curPage, item);
        });
      }
    } else {
      holder.textContent = '';
    }
  };

  public updatePerpage() {
    this.isLoading = true;
    this.loadError = false;
    this.query_string = this.Query_String + "&per_page=" + this.itemsByPage;
    if (this.name) {
      this.query_string = this.query_string + "&name=" + this.name;
    }
    this.http.get(`${this.query_string}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
      (data) => {
        this.isLoading = false;
        this.organizations = data["organizations"];
        if (!this.name) {
          this.organizations.unshift(acme_roster);
        }
        this.meta = data["meta"];
        this.count = this.meta.total_count + (!this.name ? 1 : 0);
        this.pageLen = Math.ceil(this.count / this.itemsByPage);
        this.curPage = 0;
        this.item = [];
        for (var i = 1; i <= this.pageLen; i++) {
          this.item.push(i);
        }
        setTimeout(() => this.render(this.curPage, this.item, true), 0);
      },
      (error) => {
        this.isLoading = false;
        this.loadError = true;
      }
    );
  }

  // Triggered on keyup — pushes to debounced subject
  public updateName() {
    this.name = jQuery("#name").val();
    this.searchSubject$.next(this.name);
  }

  // Actual search execution (called after debounce)
  private executeSearch(name: string) {
    if (name.length == 0 || name.length >= 3) {
      this.organizations = [];
      this.isLoading = true;
      this.loadError = false;
      this.query_string = this.Query_String + "&per_page=" + this.itemsByPage;
      if (name) {
        this.query_string = this.query_string + "&name=" + name;
      }
      this.http.get(`${this.query_string}`)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
        (data) => {
          this.isLoading = false;
          this.organizations = data["organizations"];
          if (name.length == 0) {
            this.organizations.unshift(acme_roster);
          }
          this.meta = data["meta"];
          this.count = this.meta.total_count;
          this.pageLen = this.meta.total_pages;
          this.curPage = 0;
          this.item = [];
          for (var i = 1; i <= this.pageLen; i++) {
            this.item.push(i);
          }
          this.render(this.curPage, this.item, true);
        },
        (error) => {
          this.isLoading = false;
          this.loadError = true;
        }
      );
    }
  }

  public open() {
    $(".orgs-modal").css("display", "block");
  }

  public addOrg() {
    if (this.orgName && !this.addingOrg) {
      this.addingOrg = true;
      var data: any = {
        name: this.orgName,
        roster: true,
      };
      if (this.parentOrgId) { data.parent_id = this.parentOrgId; }
      this.http
        .post(`${environment.profileURL}/api/v1/organizations.json`, data)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (result) => {
            this.addingOrg = false;
            $(".modal-dialog").addClass("hide");
            $("body").removeClass("modal-open");
            $(".orgs-modal").css("display", "none");
            this.organizations.push(result["organization"]);
            this.count += 1;
            this.orgName = "";
            this.parentOrgId = null;
            Swal.fire({
              icon: "success",
              title: "Nice!",
              text: "The Organization was added successfully!",
              timer: 2000,
              showConfirmButton: false,
            });
          },
          (error) => {
            this.addingOrg = false;
            $(".orgs-modal").css("display", "none");
            Swal.fire({
              icon: "error",
              title: "Oops!",
              text: error?.error?.errors || "Failed to add organization. Please try again.",
              timer: 3000,
              showConfirmButton: true,
            });
          }
        );
    }
  }

  public delOrg(org, index) {
    this.deleteOrg = org;
    this.deleteIndex = index;
    if (org.members_count >= 2) {
      Swal.fire({
        icon: "error",
        title: "Oops!",
        text: "Please delete all members from the organization. Then you can delete the organization itself.",
        timer: 5000,
        showConfirmButton: false,
      });
    } else {
      $(".orgs-modal-del").css("display", "block");
      if (this.delRoster) {
        this.http
          .delete(
            `${environment.profileURL}/api/v1/roster_organizations/` + org.id + ".json"
          )
          .pipe(takeUntil(this.destroy$))
          .subscribe(
            (result) => {
              this.organizations.splice(index, 1);
              this.count -= 1;
              this.delRoster = false;
              this.deleteOrg = undefined;
              this.deleteIndex = undefined;
              $(".orgs-modal-del").css("display", "none");
              Swal.fire({
                icon: "success",
                title: "Nice!",
                text: "The Organization was deleted successfully!",
                timer: 2000,
                showConfirmButton: false,
              });
            },
            (err) => {
              this.delRoster = false;
              this.deleteOrg = undefined;
              this.deleteIndex = undefined;
              $(".orgs-modal-del").css("display", "none");
              Swal.fire({
                icon: "error",
                title: "Sorry!",
                text: err?.error?.errors || "Failed to delete organization. Please try again.",
                timer: 3000,
                showConfirmButton: true,
              });
            }
          );
      }
    }
  }

  public openEditOrg(record, index) {
    this.editOrgs = index;
    this.savedOrg = record;
    this.prevRecordName = record.name;
  }

  public cancelSave(index) {
    this.organizations[this.editOrgs].name = this.prevRecordName;
    this.editOrgs = -1;
    this.savedOrg = null;
  }

  public saveOrg(record) {
    var data = {
      name: record?.name,
    };
    this.http
      .put(
        `${environment.profileURL}/api/v1/organizations/` +
          record?.id +
          ".json",
        data
      )
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (result) => {
          this.editOrgs = -1;
          this.savedOrg = null;
          Swal.fire({
            icon: "success",
            title: "Nice!",
            text: "Organization was updated successfully!",
            timer: 2000,
            showConfirmButton: false,
          });
        },
        (err) => {
          this.organizations[this.editOrgs].name = this.prevRecordName;
          this.cancelSave(this.editOrgs);
          Swal.fire({
            icon: "error",
            title: "Oops!",
            text: err?.error?.errors || "Failed to update organization. Please try again.",
            timer: 3000,
            showConfirmButton: true,
          });
        }
      );
  }

  public resetOrgName() {
    jQuery("#name").val("");
    this.updateName();
  }

  public updateMembers(members, route, recName) {
    this.teamReportService.totalOrgMembers.next(members);
    localStorage.setItem(
      "orgGraph",
      JSON.stringify({ members_count: members, orgName: recName })
    );
    this.router.navigate([route]);
  }

  public currentOrg(currentOrg) {
    localStorage.setItem("orgTotalMember", currentOrg.members_count);
    localStorage.setItem("currentOrgName", currentOrg.name);
    this.teamReportService.totalOrgMembers.next(currentOrg.members_count);
    this.teamReportService.orgData.next(currentOrg);
  }

  public openRosterPopup(name, id?: any) {
    this.rosterId = id;
    this.teamReportService.rosterName.next(name);
    $(".roster_popup").css("display", "block");
  }

  public back() {
    window.history.back();
  }

  public changeView(view = "table") {
    localStorage.setItem("rostertableHierView", view);
    this.tableHierarView = view;
  }

  searchRosterMember(e = null) {
    if (this.searchQuery.length > 2) {
      this.isGlobalSearch = true;
      this.isLoading = true;
      this.loadError = false;
      this.http
        .post(
          `${environment.profileURL}/api/v1/roster_organizations/search_members?first_name=${this.searchQuery}`,
          {}
        )
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (res: any) => {
            this.isLoading = false;
            this.organizations = res.members;
          },
          (error) => {
            this.isLoading = false;
            this.loadError = true;
          }
        );
    }
  }
}
